/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Insights_Col_Dealsshared2Inputs */

const en_coinvestments_insights_col_dealsshared2 = /** @type {(inputs: Coinvestments_Insights_Col_Dealsshared2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deals shared`)
};

/**
* | output |
* | --- |
* | "Deals shared" |
*
* @param {Coinvestments_Insights_Col_Dealsshared2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_insights_col_dealsshared2 = /** @type {((inputs?: Coinvestments_Insights_Col_Dealsshared2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Insights_Col_Dealsshared2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_insights_col_dealsshared2(inputs)
});
export { coinvestments_insights_col_dealsshared2 as "coInvestments_insights_col_dealsShared" }